import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/**
 * /about-us.
 *
 * The copy is the legacy page's, word for word — this is a framework change, not a copy
 * change, as on TopMags. Body copy that said `{company.companyname}` is written out as
 * "MagSpot.com", the way TopMags' pages write out "TopMags.com".
 *
 * The heading is the exception, and deliberately not what the legacy template rendered.
 * That said `About {company.companyname}`, so this page alone read "About MagSpot.com"
 * while TopMags, MagZoom and the breadcrumb above it all say "About Us". The odd one out
 * was the brand name, not the plain wording, so it goes.
 */
export default function AboutUs() {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'About Us' }]} />

      <PageHeading eyebrow="Customer Information">About Us</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <p>
            Here at MagSpot.com, we are your friends! From the best customer service, to the
            thousands of exclusive titles we offer including cooking, business, sports, science,
            celebrities and everything in between! We provide stress-free and affordable
            subscriptions directly from the publisher to your home for you to enjoy! And if for some
            reason you don&apos;t, our cancelation policy is fast and easy. With the lowest prices
            around, a variety of astonishing titles, and honest and helpful staff, your satisfaction
            is 100% guaranteed!
          </p>

          <p>
            MagSpot.com is located in the heart of Houston where we take pride in being based in one
            of the most dynamic and largest cities in Texas. Since 2015, our website has been
            providing the best quality subscriptions and we couldn&rsquo;t be happier to share our
            love for &quot;The Lone Star State&quot; and magazines with you!
          </p>

          <p>We welcome you to MagSpot.com and give a Big-Texas thank you!</p>
        </ContentCard>
      </div>
    </>
  );
}

AboutUs.layoutName = 'Layouts.Institutional';
